export default "__VITE_ASSET__BDduPUUG__"